export default __webpack_public_path__ + "static/media/06.30b7ea07.jpeg";